import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LandSubdivisionPackageDeleteModal',
  props: {
    isOpen: { type: Boolean },
    deleting: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  onMounted(() => document.addEventListener("keydown", closeOnEscape));
  onBeforeUnmount(() => document.removeEventListener("keydown", closeOnEscape));

  function close() {
    if (!props.deleting) emit("close");
  }

  function closeOnEscape(event: KeyboardEvent) {
    if (props.isOpen && event.key === "Escape") close();
  }

const __returned__ = { props, emit, close, closeOnEscape, onBeforeUnmount, onMounted }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})